var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-back-header __flex __flex-vc __flex-cb"},[_c('img',{staticClass:"img-logo",attrs:{"src":require("@/assets/images/common/left_icon.png"),"alt":""},on:{"click":function($event){return _vm.toPrePage()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }